import { useState, useEffect } from "react";
import { useParams, useLocation, NavLink } from "react-router-dom";
import {
  FaUser,
  FaHome,
  FaCalendarAlt,
  FaQuestionCircle,
  FaBars,
  FaTimes,
  FaShieldAlt,
} from "react-icons/fa";
import { BsClipboardCheckFill } from "react-icons/bs";
import "bootstrap/dist/css/bootstrap.min.css";

export default function Sidebar() {
  const { uid } = useParams();
  const location = useLocation();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const links = [
    { to: `/dashboard/${uid}/profile`, label: "Profile", icon: <FaUser /> },
    { to: `/dashboard/${uid}/home`, label: "Home", icon: <FaHome /> },
    { to: `/dashboard/${uid}/volunteer-view`, label: "Event", icon: <FaCalendarAlt /> },
    { to: `/dashboard/${uid}/help`, label: "Event Initiatives", icon: <BsClipboardCheckFill /> },
    { to: `/dashboard/${uid}/help-me`, label: "Help", icon: <FaQuestionCircle /> },
  ];

  return (
    <>
      {windowWidth < 768 && !isSidebarOpen && (
        <button
          className="btn btn-light m-2 position-fixed"
          style={{ zIndex: 2001, borderRadius: '12px', background: 'rgba(172,46,98,0.06)', border: 'none' }}
          onClick={() => setIsSidebarOpen(true)}
        >
          <FaBars style={{ color: "#ac2e62" }} />
        </button>
      )}

      {(isSidebarOpen || windowWidth >= 768) && (
        <div
          className="d-flex flex-column p-3 text-white position-fixed db1-sidebar"
          style={{
            width: "250px",
            height: "100vh",
            top: 0,
            left: 0,
            zIndex: 2000,
            overflowY: "auto",
            transition: "transform 0.3s ease-in-out",
            transform:
              isSidebarOpen || windowWidth >= 768
                ? "translateX(0)"
                : "translateX(-100%)",
          }}
        >
          {windowWidth < 768 && (
            <div className="d-flex justify-content-end mb-2">
              <button
                className="btn btn-light btn-sm"
                onClick={() => setIsSidebarOpen(false)}
                style={{ borderRadius: '10px' }}
              >
                <FaTimes style={{ color: "#a70a4a" }} />
              </button>
            </div>
          )}

          <div className="text-center mb-4 mt-2">
            <div style={{
              width: '80px',
              height: '80px',
              margin: '0 auto',
              borderRadius: '20px',
              background: 'rgba(255,255,255,0.06)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: '8px',
              backdropFilter: 'blur(8px)',
              border: '1px solid rgba(255,255,255,0.06)'
            }}>
              <img
                src="/images/LOGO.png"
                alt="Logo"
                style={{ width: "100%", height: "100%", objectFit: "contain" }}
              />
            </div>
            <div className="mt-2" style={{ fontSize: '0.75rem', opacity: 0.4, letterSpacing: '1px', textTransform: 'uppercase' }}>Volunteer Panel</div>
          </div>

          <div style={{ flex: 1 }}>
            <div style={{ fontSize: '0.7rem', textTransform: 'uppercase', letterSpacing: '1.5px', opacity: 0.3, padding: '0 18px', marginBottom: '10px', fontWeight: 600 }}>
              Navigation
            </div>
            <ul className="nav flex-column gap-1" style={{ padding: '0 8px' }}>
              {links.map(({ to, label, icon }) => (
                <li className="nav-item" key={label}>
                  <NavLink
                    to={to}
                    end
                    className="db1-sidebar-link"
                    style={({ isActive }) => ({
                      background: isActive ? undefined : 'transparent'
                    })}
                    onClick={() => {
                      if (windowWidth < 768) setIsSidebarOpen(false);
                    }}
                  >
                    <span className="sidebar-link-icon" style={{ fontSize: '0.95rem', width: '20px', display: 'inline-flex', justifyContent: 'center' }}>{icon}</span>
                    <span>{label}</span>
                  </NavLink>
                </li>
              ))}
            </ul>
          </div>

          <div style={{ padding: '16px 18px', borderTop: '1px solid rgba(255,255,255,0.04)', marginTop: 'auto' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <div style={{ width: '32px', height: '32px', borderRadius: '10px', background: 'rgba(255,255,255,0.06)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <FaShieldAlt style={{ fontSize: '14px', opacity: 0.4 }} />
              </div>
              <div>
                <div style={{ fontSize: '0.78rem', fontWeight: 600, opacity: 0.7 }}>TMGF</div>
                <div style={{ fontSize: '0.65rem', opacity: 0.3 }}>Volunteer Portal</div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
